module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "empresa"
    }
  }, [_vm._v("Loja")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.empresas,
      "placeholder": "TODAS"
    },
    model: {
      value: (_vm.empresaSelecionada),
      callback: function($$v) {
        _vm.empresaSelecionada = $$v
      },
      expression: "empresaSelecionada"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "situacao"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("TODAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "APROVADO"
    }
  }, [_vm._v("APROVADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CANCELADO"
    }
  }, [_vm._v("CANCELADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NÃO AUTORIZADO"
    }
  }, [_vm._v("NÃO AUTORIZADO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Duplicatas")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.possui_duplicata),
      expression: "dados.possui_duplicata"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "possui_duplicata", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("COM E SEM DUPLICATAS ANEXADAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("SOMENTE SEM DUPLICATAS ANEXADAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("SOMENTE COM DUPLICATAS ANEXADAS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.pesquisa),
      expression: "dados.pesquisa"
    }],
    ref: "filtro_pesquisa",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Busca: Entre com o NOME ou DOCUMENTO do cliente e pressione enter",
      "name": "filtro_pesquisa",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataTable($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "pesquisa", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.getDataTable
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.apiData.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even selecionavel",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.showDetalhe(item.id)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.id) + "-" + _vm._s(item.digito))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(item.data)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.usuario.empresa.fantasia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.pessoa.nome_razao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.pessoa.cpf_cnpj))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.qtd_titulo))]), _vm._v(" "), _c('td', [_c('strong', {
      class: item.status
    }, [_vm._v(_vm._s(item.status))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.possui_duplicata == 1 ? 'Sim' : 'Não'))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.apiData.from) + " até " + _vm._s(this.apiData.to) + " de " + _vm._s(this.apiData.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.apiData
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Garantias")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Protocolo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("Loja")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("Pessoa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("Cpf/Cnpj")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("Qtd.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Ṕossui Duplicata?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03ec1d7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operacao/garantias/index.vue
// module id = 381
// module chunks = 1